import { useTranslate } from "@refinedev/core";
import { HomeIcon, SettingsTileCard } from "@fawkes/ui";

import type { TileComponentProps } from "./types";

// Pleeggezinnen — foster homes / care categories. Vestiging context only (module-gated on
// `pleeggezin` in Jmix). Migrated: the card opens the in-SPA Pleeggezinnen detail
// (PleeggezinnenSettings) hosting the Opvangcategorieën management screen for the active branch.
export const PLEEGGEZINNEN_TILE_KEY = "pleeggezinnen";

const ITEM_KEYS = ["instellingen.item.opvangcategorieen"];

export function PleeggezinnenTile({ context, onOpenDetail }: TileComponentProps) {
  const t = useTranslate();
  if (context.type !== "branch") return null;
  return (
    <SettingsTileCard
      tileKey={PLEEGGEZINNEN_TILE_KEY}
      icon={<HomeIcon className="settings-tile-icon" width={16} height={16} />}
      title={t("instellingen.tile.pleeggezinnen.title")}
      description={t("instellingen.tile.pleeggezinnen.desc")}
      items={ITEM_KEYS.map((k) => t(k))}
      openLabel={t("instellingen.cta.open")}
      onOpen={() => onOpenDetail("pleeggezinnen")}
    />
  );
}
